/**
 * Общие ограничения распознавания документов (t_aba782d3).
 *
 * Используются и на сервере (`/api/recognize`, `/api/ai-builder`), и в браузере
 * для проверки файла ДО отправки. Модуль намеренно без зависимостей, чтобы его
 * можно было импортировать в клиентские компоненты.
 */
export const RECOGNITION_ALLOWED_TYPES = [
	"application/pdf",
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/vnd.ms-excel",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"text/plain",
	"text/csv",
	"image/jpeg",
	"image/jpg",
	"image/png",
	"image/webp",
	"image/bmp",
];

/** Лимит одного файла — 20 МБ. */
export const RECOGNITION_MAX_FILE_SIZE = 20 * 1024 * 1024;

/** Значение атрибута accept для input[type=file]. */
export const RECOGNITION_ACCEPT = [
	...RECOGNITION_ALLOWED_TYPES,
	".pdf",
	".doc",
	".docx",
	".xls",
	".xlsx",
	".txt",
	".csv",
].join(",");
